// extracted by mini-css-extract-plugin
module.exports = {"order":"order_info_order__20qgE","orderNum":"order_info_orderNum__1JNY5","menu":"order_info_menu__1qz33","count":"order_info_count__1m3pW","price":"order_info_price__28qMD"};